const hasPriceQualifierLabel = (
    pricingQualifierLabel: string | null | undefined
): boolean => {
    if (!pricingQualifierLabel) return false;
    return !['POA', 'Sale by tender'].includes(pricingQualifierLabel);
};

export default hasPriceQualifierLabel;
